import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0dcd64f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sc-dialog",
  ref: "scDialog"
};
const _hoisted_2 = {
  class: "el-dialog__title"
};
const _hoisted_3 = {
  class: "sc-dialog__headerbtn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_icon_bottom_left = _resolveComponent("el-icon-bottom-left");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_icon_full_screen = _resolveComponent("el-icon-full-screen");
  const _component_el_icon_close = _resolveComponent("el-icon-close");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, _mergeProps({
    ref: "dialog",
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.dialogVisible = $event),
    fullscreen: $data.isFullscreen
  }, _ctx.$attrs, {
    "show-close": false
  }), {
    header: _withCtx(() => [_renderSlot(_ctx.$slots, "header", {}, () => [_createElementVNode("span", _hoisted_2, _toDisplayString($props.title), 1)], true), _createElementVNode("div", _hoisted_3, [$props.showFullscreen ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      "aria-label": "fullscreen",
      type: "button",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.setFullscreen && $options.setFullscreen(...args))
    }, [$data.isFullscreen ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      class: "el-dialog__close"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon_bottom_left)]),
      _: 1
    })) : (_openBlock(), _createBlock(_component_el_icon, {
      key: 1,
      class: "el-dialog__close"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon_full_screen)]),
      _: 1
    }))])) : _createCommentVNode("", true), $props.showClose ? (_openBlock(), _createElementBlock("button", {
      key: 1,
      "aria-label": "close",
      type: "button",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.closeDialog && $options.closeDialog(...args))
    }, [_createVNode(_component_el_icon, {
      class: "el-dialog__close"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon_close)]),
      _: 1
    })])) : _createCommentVNode("", true)])]),
    footer: _withCtx(() => [_renderSlot(_ctx.$slots, "footer", {}, undefined, true)]),
    default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])), [[_directive_loading, $props.loading]])]),
    _: 3
  }, 16, ["modelValue", "fullscreen"])], 512);
}